import Model, { attr } from "@ember-data/model";
import type BioExamPrescription from "./bio-exam/bio-exam-prescription";

export default class ConfigurationBioExamModel extends Model {
  @attr("bio-exam-prescriptions")
  declare bioExamPrescriptions: Array<BioExamPrescription>;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "configuration-bio-exam": ConfigurationBioExamModel;
  }
}
